import { ToroAccountDetailed } from './../../../api/models/toro-account-detailed.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ToroAccountSimple } from './../../../api/models/toro-account-simple.model';

export function selectAccount(account: ToroAccountSimple): number {
    return account.Id;
}

// export interface AccountState extends EntityState<ToroAccountSimple>

export const accountAdapter: EntityAdapter<ToroAccountSimple> = createEntityAdapter<ToroAccountSimple>({
    selectId: selectAccount
});

export interface AccountState extends EntityState<ToroAccountSimple> {
    currentAccount: ToroAccountDetailed;
    total: number;
    loaded: boolean;
}
